export const SELECT_SESSION = "@CHAT_HISTORY/SELECT_SESSION";
export const SET_SESSION_RESPONSE = "@CHAT_HISTORY/SET_SESSION_RESPONSE";
export const SET_SESSION_GETTER_SETTER = "@CHAT_HISTORY/SET_SESSION_GETTER_SETTER";
export const SET_IS_GETTER_SETTER_DRAWER_OPEN = "@CHAT_HISTORY/SET_IS_GETTER_SETTER_DRAWER_OPEN";
export const SET_LABEL_AND_CLOSING_CODE_STATE_HISTORY = "@CHAT_HISTORY/SET_LABEL_AND_CLOSING_CODE_STATE_HISTORY";
